import { render, staticRenderFns } from "./ShowImageInCard.vue?vue&type=template&id=becf9ec8&scoped=true"
import script from "./ShowImageInCard.vue?vue&type=script&lang=js"
export * from "./ShowImageInCard.vue?vue&type=script&lang=js"
import style0 from "./ShowImageInCard.vue?vue&type=style&index=0&id=becf9ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becf9ec8",
  null
  
)

export default component.exports